import clsx from 'clsx';
import { XIcon } from 'game/icons/XIcon';
import { createStyles } from 'game/lib/createStyles';
import { colors, fontWeight, fonts } from 'game/styles/theme';
import { PropsWithChildren } from 'react';

const classes = createStyles({
  modal: {
    fontFamily: fonts.nunito,
    borderRadius: 12,
    boxShadow: `5px 5px 0 ${colors.darkBlue}`,
    background: colors.eggShell,
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '100%',
    overflow: 'hidden',
  },
  header: {
    borderRadius: '8px 8px 0 0',
    background: colors.accent,
    color: colors.white,
    fontWeight: fontWeight.extraBold,
    fontSize: 18,
    padding: '10px 10px 10px 20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  body: {
    padding: 20,
    overflow: 'auto',
    flexGrow: 1,
  },
  footer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
  },
  close: {
    display: 'block',
    marginLeft: 10,
    '& > svg': { display: 'block' },
  },
});

interface ModalProps {
  heading: React.ReactNode,
  onClose: () => void,
}

export const Modal: React.FC<PropsWithChildren<ModalProps>> = ({ heading, children, onClose }) => {
  return (
    <div className={classes.modal}>
      <div className={classes.header}>
        {heading}
        <div>
          <button type="button" className={classes.close} onClick={onClose}>
            <XIcon width={22} height={22} fill={colors.darkBlue} />
          </button>
        </div>
      </div>
      {children}
    </div>
  );
};

export const ModalBody: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...rest }) => (
  <div className={clsx(classes.body, className)} {...rest} />
);

export const ModalFooter: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...rest }) => (
  <div className={clsx(classes.footer, className)} {...rest} />
);
